import request from '@/utils/request'

// 查询敏感内容命中日志分页
export function pageSensitiveLog(data) {
  return request({
    url: '/user/sensitive-log/page',
    method: 'post',
    data: data
  })
}

// 查询敏感内容命中日志列表
export function listSensitiveLog(data) {
  return request({
    url: '/user/sensitive-log/list',
    method: 'post',
    data: data
  })
}

// 查询敏感内容命中日志详情
export function getSensitiveLog(id) {
  return request({
    url: '/user/sensitive-log/detail',
    method: 'get',
    params: { id }
  })
}

// 导出敏感内容命中日志
export function exportSensitiveLog(data) {
  return request({
    url: '/user/sensitive-log/export',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
